import { Button, styled } from '@mui/material';
import { buttonClasses } from '@mui/material/Button';

// Acción principal de la página Disponibilidad: CTA blanco del design system
// (texto negro; el estilo legado dejaba texto blanco sobre botón blanco).
const StyledAvailabilityRepeatButton = styled(Button)(() => ({
  // CTA mode-aware (variables CSS): blanco/negro en oscuro, negro/blanco en claro.
  backgroundColor: 'var(--otx-cta-bg)',
  border: '1px solid transparent',
  borderRadius: 10,
  color: 'var(--otx-cta-text)',
  flexShrink: 0,
  fontWeight: 800,
  padding: '7px 16px',
  textTransform: 'none',
  transition:
    'filter 200ms cubic-bezier(0.32, 0.72, 0, 1), transform 200ms cubic-bezier(0.32, 0.72, 0, 1)',
  '& span': {
    color: 'inherit'
  },
  '&:hover': {
    backgroundColor: 'var(--otx-cta-bg)',
    color: 'var(--otx-cta-text)',
    filter: 'brightness(0.94)'
  },
  '&:active': {
    transform: 'scale(0.98)'
  },
  [`&.${buttonClasses.disabled}`]: {
    backgroundColor: 'var(--otx-btn-disabled-bg)',
    color: 'var(--otx-btn-disabled-text)'
  }
}));

export default StyledAvailabilityRepeatButton;
